import type { ChatUser } from "#shared/types/chat";
import { userAvatarSrc, userDisplayName } from "~/utils/deleted-user";

export const useChatUsersStore = defineStore("chat/users", () => {
  const users = ref<Record<string, ChatUser>>({});

  const mergeUsers = (incoming: ChatUser[] | undefined | null) => {
    if (!incoming?.length) return;
    const next = { ...users.value };
    for (const user of incoming) {
      if (!user?.id) continue;
      next[user.id] = { ...next[user.id], ...user };
    }
    users.value = next;
  };

  const getUser = (id: string | undefined | null): ChatUser | undefined => {
    if (!id) return undefined;
    return users.value[id];
  };

  const getUserName = (id: string | undefined | null): string => {
    return userDisplayName(getUser(id));
  };

  const isUserDeleted = (id: string | undefined | null): boolean =>
    !!getUser(id)?.isDeleted;

  /** Аватар с учётом удаления: у удалённого — гость. */
  const getUserAvatar = (id: string | undefined | null): string | undefined =>
    userAvatarSrc(getUser(id), getUser(id)?.avatarUrl);

  const resetState = () => {
    users.value = {};
  };

  return {
    users,
    mergeUsers,
    getUser,
    getUserName,
    isUserDeleted,
    getUserAvatar,
    resetState,
  };
});